export const baseUrlApiWithoutTenant = `${import.meta.env.VITE_BASE_URL_API}/`;
